import { SurveyState, SurveyStateObject } from "./types";

export const surveyStates: SurveyStateObject[] = [
  {
    state: SurveyState.START,
    question: "How are you liking activities on Capital One Travel?",
    optionType: "radio",
    options: [
      {
        title: "It’s great — I’m planning to book / already booked",
        next: SurveyState.POSITIVE,
      },
      {
        title: "Not sure yet — still browsing",
        next: SurveyState.DONE,
      },
      {
        title: "I have some issues — it doesn’t meet my expectations",
        next: SurveyState.ISSUES,
      },
    ],
    prev: null,
    showBack: false,
    showNext: true,
    randomizeOptions: false,
  },
  {
    state: SurveyState.POSITIVE,
    question: "What made activities work well for you? (Select all that apply)",
    optionType: "checkbox",
    options: [
      "Found activities I’m interested in",
      "Prices were good",
      "Easy to browse and book",
      "Reviews were helpful",
      "Earning 5X miles is great",
      "Photos were compelling",
      "Descriptions and information were clear",
      "Availability matched my dates",
      "Duration/times fit my schedule",
    ],
    next: SurveyState.DONE,
    prev: SurveyState.START,
    showBack: true,
    showNext: true,
    randomizeOptions: true,
  },
  {
    state: SurveyState.ISSUES,
    question: "What best describes why activities is falling short?",
    optionType: "radio",
    options: [
      {
        title: "I couldn’t find an activity I wanted",
        next: SurveyState.LOOKING_FOR_SOMETHING_ELSE,
      },
      {
        title: "I found the same activity cheaper elsewhere",
        next: SurveyState.BETTER_PRICE_ELSEWHERE,
      },
      {
        title: "Prices felt too high",
        next: SurveyState.PRICES_TOO_HIGH,
      },
      {
        title: "I’m just browsing / need more time",
        next: SurveyState.DONE,
      },
      {
        title: "No availability for my dates",
        next: SurveyState.DONE,
      },
      {
        title: "I needed more information",
        next: SurveyState.MORE_INFO_NEEDED,
      },
      {
        title: "Reviews weren’t convincing",
        next: SurveyState.INSUFFICIENT_REVIEWS,
      },
      {
        title: "Booking felt complicated",
        next: SurveyState.BOOKING_COMPLICATED,
      },
      {
        title: "I couldn’t find the checkout button",
        next: SurveyState.DONE,
      },
    ],
    prev: SurveyState.START,
    showBack: true,
    showNext: true,
    randomizeOptions: true,
  },
  {
    state: SurveyState.LOOKING_FOR_SOMETHING_ELSE,
    question: "What were you hoping to find?",
    optionType: "radio",
    options: [
      {
        title: "Specific landmark or attraction",
        next: SurveyState.DONE,
      },
      {
        title: "Certain category (food tour, museum, boat, day trip)",
        next: SurveyState.DONE,
      },
      {
        title: "Time of day / duration",
        next: SurveyState.DONE,
      },
      {
        title: "Family-friendly / accessibility needs",
        next: SurveyState.DONE,
      },
      {
        title: "Language or private option",
        next: SurveyState.DONE,
      },
    ],
    prev: SurveyState.ISSUES,
    showBack: true,
    showNext: true,
    randomizeOptions: false,
  },
  {
    state: SurveyState.BETTER_PRICE_ELSEWHERE,
    question: "Where did you see a better price?",
    optionType: "radio",
    options: [
      {
        title: "Airbnb Experiences",
        next: SurveyState.DONE,
      },
      {
        title: "Viator / Tripadvisor",
        next: SurveyState.DONE,
      },
      {
        title: "GetYourGuide",
        next: SurveyState.DONE,
      },
      {
        title: "Klook",
        next: SurveyState.DONE,
      },
      {
        title: "Direct tour provider site",
        next: SurveyState.DONE,
      },
    ],
    prev: SurveyState.ISSUES,
    showBack: true,
    showNext: true,
    randomizeOptions: false,
  },
  {
    state: SurveyState.PRICES_TOO_HIGH,
    question: "What price per person would make you consider booking?",
    optionType: "radio",
    options: [
      {
        title: "<$20",
        next: SurveyState.DONE,
      },
      {
        title: "$20-49",
        next: SurveyState.DONE,
      },
      {
        title: "$50-79",
        next: SurveyState.DONE,
      },
      {
        title: "$80-119",
        next: SurveyState.DONE,
      },
      {
        title: "$120-199",
        next: SurveyState.DONE,
      },
      {
        title: "$200-299",
        next: SurveyState.DONE,
      },
      {
        title: "$300+",
        next: SurveyState.DONE,
      },
    ],
    prev: SurveyState.ISSUES,
    showBack: true,
    showNext: true,
    randomizeOptions: false,
  },
  {
    state: SurveyState.MORE_INFO_NEEDED,
    question: "What info was missing? (Select all that apply)",
    optionType: "checkbox",
    options: [
      "Detailed itinerary / what’s included",
      "Meeting point / start time",
      "Pick up / drop off details",
      "Cancellation policy / refunds",
      "Photos or video",
      "Language / guide details",
      "Age / accessibility info",
    ],
    next: SurveyState.DONE,
    prev: SurveyState.ISSUES,
    showBack: true,
    showNext: true,
    randomizeOptions: false,
  },
  {
    state: SurveyState.INSUFFICIENT_REVIEWS,
    question: "What about the reviews?",
    optionType: "radio",
    options: [
      {
        title: "Not enough reviews",
        next: SurveyState.DONE,
      },
      {
        title: "Ratings were too low",
        next: SurveyState.DONE,
      },
      {
        title: "Reviews didn’t feel recent / relevant",
        next: SurveyState.DONE,
      },
      {
        title: "Too much text — couldn’t find a relevant review",
        next: SurveyState.DONE,
      },
    ],
    prev: SurveyState.ISSUES,
    showBack: true,
    showNext: true,
    randomizeOptions: false,
  },
  {
    state: SurveyState.BOOKING_COMPLICATED,
    question: "What felt hard?",
    optionType: "radio",
    options: [
      {
        title: "Too many steps",
        next: SurveyState.DONE,
      },
      {
        title: "Confusing options or add-ons",
        next: SurveyState.DONE,
      },
      {
        title: "Error or bug",
        next: SurveyState.DONE,
      },
    ],
    prev: SurveyState.ISSUES,
    showBack: true,
    showNext: true,
    randomizeOptions: false,
  },
  {
    state: SurveyState.DONE,
    title: "Thanks for the feedback",
    question:
      "It helps us improve activities. Enjoy your trip, and earn 5X miles on activities.",
    optionType: "none",
    prev: null,
    showBack: false,
    showNext: false,
  },
];
